import type { MusicVideoEffect } from 'fym-shared/src/music24/musicVideoEffects';

/** The effects lane has at most this many rows; more overlapping effects share the last row. */
export const EFFECT_LANE_ROWS = 3;

/**
 * The row of each effect on the effects lane: effects that overlap go on different rows, so a
 * transition over a shot effect stays visible and can be grabbed. The first row that is free at
 * the start of the effect wins. Pure.
 */
export function effectRows(effects: readonly MusicVideoEffect[]): { rows: Map<string, number>; count: number } {
  const ends: number[] = [];
  const rows = new Map<string, number>();
  const sorted = [...effects].sort((a, b) => a.startSec - b.startSec);
  for (const effect of sorted) {
    let row = ends.findIndex((endSec) => endSec <= effect.startSec + 0.0005);
    if (row === -1) {
      row = Math.min(ends.length, EFFECT_LANE_ROWS - 1);
    }
    ends[row] = Math.max(ends[row] ?? 0, effect.endSec);
    rows.set(effect.id, row);
  }
  return { rows, count: Math.max(1, Math.min(EFFECT_LANE_ROWS, ends.length)) };
}
